import {
  IInput,
  IField,
  IFormButton,
} from 'app/services/api5-service/api.interface';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ISP_TYPOGRAPHY_VAR } from 'common/colors';

import { PromoCodeProps } from './model/promo-code-props.interface';

import {
  ISPFieldConfig,
  ISPFieldType,
  ISPFieldWrapper,
  ISPFormState,
} from '../../model';
import { getButton$ } from '../button/button.utils';

/**
 * Get props for promocode field
 *
 * @param control - control (subfield) metadata
 * @param button - binded input button
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getPromoCodeProps(
  control: IInput,
  button: IFormButton,
  field: IField,
  state: ISPFormState,
): PromoCodeProps {
  return {
    originalControl: control,
    originalField: field,
    fieldSettings$: of({
      labelWeight: `var(${ISP_TYPOGRAPHY_VAR.bold})`,
      labelSize: '18px',
      labelOffset: '15px',
      displayMode: 'input-like',
      tagPlace: 'field',
    }),
    button$: getButton$(button, state),
    messages$: state.mixedService
      .getControlPlaceholder$(control, ISPFieldType.PromoCode)
      .pipe(
        map(placeholder => ({
          // @TODO i.ablov, d.bronnikov REMOVE HARDCODE (success message)
          success: 'Промокод успешно применен',
          placeholder,
        })),
      ),
    displayErrorUnderField: true,
    style: {
      '--error-padding-left': '0',
      '--error-margin-top': '8px',
    },
  };
}

/**
 * Get config for promocode field
 *
 * @param control - control (subfield) metadata
 * @param button - binded input button
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getPromoCodeConfig(
  control: IInput,
  button: IFormButton,
  field: IField,
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.PromoCode> {
  const props = getPromoCodeProps(control, button, field, state);

  const config: ISPFieldConfig<ISPFieldType.PromoCode> = {
    key: control.$name,
    type: ISPFieldType.PromoCode,
    wrappers: [ISPFieldWrapper.FieldBase, ISPFieldWrapper.ValidationError],
    props,
  };

  return config;
}
